<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 15:00:45
 * @LastEditTime: 2020-05-22 11:07:45
 * @Description: 数据内容区
 -->
<template>
  <div class="data-content">
    <data-table
      :paper-id="paperId"
      :data="contentData.tableData"
      @set-order="setOrderHandler"
      @repull-list="repullListHandler" />
    <data-page
      :total="contentData.total" :page="contentData.page" @index-change="pageIndexChangedHandler" />
  </div>
</template>

<script>
import DataTable from './DataTable.vue';
import DataPage from './DataPage.vue';

export default {
  name: 'DataContent',
  components: {
    DataTable,
    DataPage,
  },
  props: {
    paperId: { type: [Number, String], required: true },
    contentData: { type: Object, required: true },
  },
  methods: {
    /**
     * 设置排序方式处理函数
     */
    setOrderHandler(order) {
      this.$emit('set-order', order);
    },
    /**
     * 重新请求考生答题详情列表
     */
    repullListHandler() {
      this.$emit('repull-list');
    },
    /**
     * 分页索引改变处理函数
     */
    pageIndexChangedHandler(index) {
      this.$emit('index-change', index);
    },
  },
};
</script>

<style lang="less" scoped>
.data-content {
  width: 100%;
}
</style>
